import { Loading } from '@components/loadling';
import { initSdk } from '@proccess/api';
import { actions } from '@store/reducer';
import { sSelect } from '@store/saga';
import { AxiosResponse } from 'axios';
import { isEqual } from 'lodash';
import { all, call, delay, fork, put, select, takeEvery } from 'redux-saga/effects';
import { ReqSchedules, SetDataSchedule } from './@define/types';

function* requestScheduleStep({ payload: { step, select_item } }: ReqSchedules) {
  try {
    Loading.Show();
    const payload = {
      to_fetch: step,
    } as any;

    if (select_item) {
      const { subject, doctor, service, date } = select_item;
      if (subject?.id) {
        payload.subject_id = subject?.id;
      }
      if (doctor?.id) {
        payload.doctor_id = doctor?.id;
      }
      if (service?.id) {
        payload.service_id = service?.id;
      }
      if (date?.id) {
        payload.date = date?.id;
      }
    }

    const { data }: AxiosResponse = yield call(() =>
      initSdk.get('/admin/schedules', { params: { ...payload } })
    );

    console.info('🚀 response requestScheduleStep:', data);

    if (data) {
      yield put(
        actions.saveScheduleStep({
          data: isEqual(step, 'date')
            ? data.unique_available_dates
            : data.schedules.map((x: any) => x[isEqual(step, 'time') ? 'ptime' : step]),
          step,
        })
      );
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestScheduleStep() {
  yield takeEvery(actions.requestScheduleStep, requestScheduleStep);
}

function* setDataSchedule({ payload: { data, step, next_step = '', end } }: SetDataSchedule) {
  try {
    const { schedule } = yield select(sSelect);

    yield call(() => delay(100));

    yield !end &&
      put(
        actions.requestScheduleStep({
          step: next_step,
          select_item: { ...schedule.scheduled, [step]: data },
        })
      );
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherSetDataSchedule() {
  yield takeEvery(actions.setDataScheduled, setDataSchedule);
}

const scheduleSagas = function* root() {
  yield all([fork(watcherRequestScheduleStep), fork(watcherSetDataSchedule)]);
};
export { scheduleSagas };
